// extracted by mini-css-extract-plugin
export default {"notes-list":"NotesList_notes-list__OoZ4R"};